import {
    FETCH_TIRE_BRANDS,
    NEW_TIRE_BRAND,
    NEW_TIRE_BRAND_SUCCESS,
    RECEIVE_TIRE_BRANDS,
    FETCH_TIRE_BANDS,
    RECEIVE_TIRE_BANDS,
    FETCH_TIRE_MODELS,
    RECEIVE_TIRE_MODELS,
    NEW_TIRE_MODEL,
    NEW_TIRE_MODEL_SUCCESS,
    FETCH_TIRE_SIZES,
    RECEIVE_TIRE_SIZES,
    NEW_TIRE_SIZE,
    NEW_TIRE_SIZE_SUCCESS, NEW_BANDA, NEW_BANDA_SUCCESS,
    FETCH_ITEM_CODIGO_BARRAS,
    RECEIVE_ITEM_CODIGO_BARRAS
} from "../actions/actionTypes";
import dataObjectFromFile from "../assets/mock/1/state0.json";

const initialState = () => {


    const at = localStorage.getItem('accessToken');
    if (at && at == "mock") {
        return {
            ...dataObjectFromFile.tires
        }
    }


    return {
        isFetchingTireBrands: false,
        fabricantes: {data: []},

        isFetchingTireModels: false,
        modelos: [],

        isFetchingTireSizes: false,
        medidas: [],

        isFetchingTireBands: false,
        bandas: [],

        itemCodigoBarras: []
    }
}

export default (state = initialState(), action) => {
    let newArray = [];
    switch(action.type) {
        case FETCH_TIRE_BRANDS:
            return {
                ...state,
                isFetchingTireBrands: true
            }
            break;
        case RECEIVE_TIRE_BRANDS:
            return {
                ...state,
                isFetchingTireBrands: false,
                fabricantes: action.payload
            }
            break;

        case NEW_TIRE_BRAND:
            return {
                ...state,
                isFetchingTireBrands: true
            }
            break;

        case NEW_TIRE_BRAND_SUCCESS:
            newArray = state.fabricantes.data;
            newArray.push(action.payload);
            const o = {
                ...state.fabricantes,
                data: newArray
            }
            return {
                ...state,
                isFetchingTireBrands: false,
                fabricantes: o
            }
            break;

        case FETCH_TIRE_MODELS:
            return {
                ...state,
                isFetchingTireModels: true
            }
            break;
        case RECEIVE_TIRE_MODELS:
            return {
                ...state,
                isFetchingTireModels: false,
                modelos: action.payload
            }
            break;

        case NEW_TIRE_MODEL:
            return {
                ...state,
                isFetchingTireModels: true
            }
            break;

        case NEW_TIRE_MODEL_SUCCESS:

            newArray = state.modelos.data;
            newArray.push(action.payload);
            const om = {
                ...state.fabricantes,
                data: newArray
            }
            return {
                ...state,
                isFetchingTireModels: false,
                modelos: om
            }
            break;

        case FETCH_TIRE_SIZES:
            return {
                ...state,
                isFetchingTireSizes: true
            }
        case RECEIVE_TIRE_SIZES:
            return {
                ...state,
                isFetchingTireSizes: false,
                medidas: action.payload
            }
        case NEW_TIRE_SIZE:
            return {
                ...state,
                isFetchingTireSizes: true
            }
        case NEW_TIRE_SIZE_SUCCESS:
            newArray = state.medidas.data;
            newArray.push(action.payload);
            const omm = {
                ...state.fabricantes,
                data: newArray
            }
            return {
                ...state,
                isFetchingTireSizes: false,
                medidas: omm
            }
            break;

        case FETCH_TIRE_BANDS:
            return {
                ...state,
                isFetchingTireBands: true
            }
        case RECEIVE_TIRE_BANDS:
            return {
                ...state,
                isFetchingTireBands: false,
                bandas: action.payload
            }

        case NEW_BANDA:
            return {
                ...state,
                isFetchingTireSizes: true
            }
        case NEW_BANDA_SUCCESS:
            newArray = state.bandas.data;
            newArray.push(action.payload);
            const oB = {
                ...state.fabricantes,
                data: newArray
            }
            return {
                ...state,
                isFetchingTireSizes: false,
                bandas: oB
            }
            break;

        case FETCH_ITEM_CODIGO_BARRAS:
            return {
                ...state,

            }
            break;
        case RECEIVE_ITEM_CODIGO_BARRAS:
            return {
                ...state,

                itemCodigoBarras: action.payload
            }
            break;


        default:
            return state;
    }
}
